import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';
import { type CamelCasedStudentNetworkEvent } from 'StudentNetworkEvent';
import { originalUrl } from 'hasResizableImages';
import { type GetStudentNetworkEventsParams, type GetStudentNetworkEventsResponse } from './studentNetworkV2Api.types';

type EventsResult = {
    events: CamelCasedStudentNetworkEvent[];
    totalCount: number;
};

export const studentNetworkEventsV2Api = createApi('studentNetworkEventsV2Api', {
    ...getBackRoyalApiBaseConfig('studentNetworkEventsV2Api'),
    keepUnusedDataFor: Infinity,
    endpoints: builder => ({
        getStudentNetworkEvents: builder.query<EventsResult, GetStudentNetworkEventsParams>({
            query: ({ filters, limit, offset, sort, direction }) => ({
                url: 'student_network_events.json',
                method: 'GET',
                params: { filters, limit, offset, sort, direction },
            }),
            transformResponse: (response: GetStudentNetworkEventsResponse) => ({
                events: (response.contents.studentNetworkEvents ?? []).map(event => {
                    if (event.image?.formats?.original?.url) {
                        event.image.formats.original.url = originalUrl(event.image)!;
                    }
                    return event;
                }),
                totalCount: response.meta.totalCount,
            }),
        }),
        getStudentNetworkEventById: builder.query<CamelCasedStudentNetworkEvent | undefined, string>({
            query: eventId => ({
                url: 'student_network_events.json',
                method: 'GET',
                // start_time: 0 overrides the API's default "end_time >= now" filter
                // so past events can be loaded via deep link. include_tbd ensures
                // date-TBD events are also included.
                params: { filters: { id: eventId, start_time: 0, include_tbd: true }, limit: 1 },
            }),
            transformResponse: (response: GetStudentNetworkEventsResponse) => {
                const event = response.contents.studentNetworkEvents[0];
                if (event?.image?.formats?.original?.url) {
                    event.image.formats.original.url = originalUrl(event.image)!;
                }
                return event;
            },
        }),
    }),
});

export const { useGetStudentNetworkEventsQuery, useGetStudentNetworkEventByIdQuery } = studentNetworkEventsV2Api;
